export function getOnboardMimic(userId, tenantId) {
  return {
    method: 'POST',
    body: JSON.stringify({
      user_id: userId,
      tenant_id: tenantId,
    }),
    path: 'onboard/mimic',
  };
}

export function createOnboardAccount(tenantId) {
  return {
    method: 'POST',
    body: JSON.stringify({ tenant_id: tenantId }),
    path: 'onboard/accounts',
  };
}

export function searchOnboardAccount(email = null, phoneNumber = null) {
  const params = new URLSearchParams();
  if (email && email !== '') {
    params.append('email', email);
  }
  if (phoneNumber && phoneNumber !== '') {
    params.append('phone', phoneNumber);
  }
  return {
    path: `onboard/accounts?${params.toString()}`,
  };
}

export function getOnboardAccountByTenantId(tenantId) {
  return {
    path: `tenants/${tenantId}/onboard_account`,
    method: 'GET',
    skipBodyCheck: true,
  };
}

export function updateOnboardAccount(accountData) {
  return {
    method: 'PUT',
    body: JSON.stringify(accountData),
    path: `onboard/accounts/${accountData.id}`,
  };
}

export function deleteOnboardAccount(accountId) {
  return {
    method: 'DELETE',
    path: `onboard/accounts/${accountId}`,
  };
}
